export function googleTranslateElementInit() {
  new window.google.translate.TranslateElement(
    {
      pageLanguage: 'en|en',
    },
    'wfTranslator'
  );
}

function GTranslateGetCurrentLang() {
  var keyValue = document['cookie'].match('(^|;) ?googtrans=([^;]*)(;|$)');
  return keyValue ? keyValue[2].split('/')[2] : null;
}

function GTranslateFireEvent(element, event) {
  try {
    if (document.createEventObject) {
      var evt = document.createEventObject();
      element.fireEvent('on' + event, evt);
    } else {
      var evt = document.createEvent('HTMLEvents');
      evt.initEvent(event, true, true);
      element.dispatchEvent(evt);
    }
  } catch (e) {
    console.log(e);
  }
}

export function doGTranslate(lang_pair) {
  if (lang_pair.value) lang_pair = lang_pair.value;
  if (lang_pair === '') return;
  var lang = lang_pair.split('|')[1];
  if (lang === 'en') {
    window.location.reload();
    return;
  }
  //if (GTranslateGetCurrentLang() === null && lang === lang_pair.split('|')[0]) return;
  var teCombo;
  var sel = document.getElementsByTagName('select');
  for (var i = 0; i < sel.length; i++)
    if (/goog-te-combo/.test(sel[i].className)) {
      teCombo = sel[i];
      break;
    }
  if (
    document.getElementById('wfTranslator') === null ||
    document.getElementById('wfTranslator').innerHTML.length === 0 ||
    teCombo.length === 0 ||
    teCombo.innerHTML.length === 0
  ) {
    setTimeout(function () {
      doGTranslate(lang_pair);
    }, 500);
  } else {
    teCombo.value = lang;
    GTranslateFireEvent(teCombo, 'change');
  }
}
